import { isDirectSalesCampaignCloned } from 'components/pages/Planner/hooks/utils/isDirectSalesCampaignCloned';

export const getDealDisplayName = (
  dealName: string,
  dealId: string,
  originalCampaignId: string | undefined,
  displayCampaignId: string,
): string => {
  if (dealName) return dealName;

  if (isDirectSalesCampaignCloned(dealId) && originalCampaignId) return originalCampaignId;

  if (!isDirectSalesCampaignCloned(dealId) && displayCampaignId) return displayCampaignId;

  return 'New campaign';
};
